import u from "./ui.module.css";

export default function FormSection({
  title,
  description,
  children,
  className = "",
  variant = "default",
}) {
  return (
    <section
      className={`${u.formSection} ${variant === "muted" ? u.formSectionMuted : ""} ${className}`}
    >
      {title ? (
        <header className={u.formSectionHeader}>
          <h3 className={u.formSectionTitle}>{title}</h3>
          {description ? (
            <p className={u.formSectionDesc}>{description}</p>
          ) : null}
        </header>
      ) : null}
      <div className={u.formSectionBody}>{children}</div>
    </section>
  );
}

export function FormGrid({ children, cols = 2, className = "" }) {
  return (
    <div
      className={`${u.formGrid} ${cols === 1 ? u.formGrid1 : ""} ${className}`}
    >
      {children}
    </div>
  );
}

export function FormGridSpan({ children, span = 2 }) {
  return (
    <div
      className={span === 2 ? u.formGridSpan2 : u.formGridSpan1}
      style={{ gridColumn: span === 2 ? "1 / -1" : undefined }}
    >
      {children}
    </div>
  );
}
